module.exports = __webpack_public_path__ + "img/internship_active.6bedcf25.svg";